<template>
  <div>
    <div class="record1"></div>
    <div class="record2">
      <el-form ref="added" inline size="medium">
        <el-form-item label="名称">
          <el-input @keyup.enter.native="search" v-model="query.name" placeholder="请输入名称"
            clearable show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="分类">
          <el-select v-model="query.type" placeholder="请选择分类" clearable>
            <el-option label="全部" value=""></el-option>
            <el-option :label="item.label" :value="item.value" v-for="(item,i) in types" :key="i"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报名状态">
          <el-select v-model="query.enroll_status" placeholder="请选择状态" clearable>
            <el-option label="全部" value=""></el-option>
            <el-option label="报名中" value="10"></el-option>
            <el-option label="未开始" value="20"></el-option>
            <el-option label="已结束" value="30"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item v-if="JudgeButton(role_permission,'activity/query')">
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        </el-form-item>
        <el-form-item v-if="JudgeButton(role_permission,'activity/query')">
          <el-button type="info" icon="el-icon-refresh-left" @click="query.name= '';query.type='';query.enroll_status='';search()">重置</el-button>
        </el-form-item>
        <el-form-item v-if="JudgeButton(role_permission,'activity/increase')">
          <el-button type="success" icon="el-icon-circle-plus" @click="reset('')"> 新增 </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="record3">
      <el-table v-loading='loading' stripe border :data="list" tooltip-effect="dark" style="width: 98%">
        <el-table-column align='center' prop="name" label="活动名称">
        </el-table-column>
        <el-table-column align='center' prop='type' label="分类">
          <template slot-scope="scope">
            <span>{{ types.find(i=>i.value == scope.row.type).label }}</span>
          </template>
        </el-table-column>
        <el-table-column align='center' prop="created_user" label="创建人">
        </el-table-column>

        <el-table-column align='center' prop="created_at" label="创建时间">
        </el-table-column>

        <el-table-column align='center' label="报名人数" width="180">
          <template slot-scope="scope">
            <el-link type="primary" style="text-decoration: underline;font-size: 15px;" :underline='false' @click="$router.push({ 
              path: '/enrollList',
              query: {
                row: JSON.stringify(scope.row)
              }
            })" v-if="scope.row.activity_enroll.length">{{ scope.row.activity_enroll.length }}</el-link>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column align='center' label="报名状态">
          <template slot-scope="scope">
            <span v-if="scope.row.enroll_status == 10">报名中</span>
            <span v-if="scope.row.enroll_status == 20">未开始</span>
            <span v-if="scope.row.enroll_status == 30">已结束</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align='center'>
          <template slot-scope="scope">
            <el-button v-if="JudgeButton(role_permission,'activity/edit')" size="mini" type="primary"
              @click="reset(scope.row.id)">编辑</el-button>
            <el-button v-if="JudgeButton(role_permission,'activity/delete')" size="mini"
               type="danger" @click="handleDelete(scope.row)">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin: 30px auto;text-align: center;" v-if="query.total > 0"
        @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="query.page"
        :page-sizes="[10, 20, 50, 100]" :page-size="query.page_limit" layout="total, sizes, prev, pager, next, jumper"
        :total="query.total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
  import userInfoAPI from '@/api/api';
  var that;
  export default {
    props: {},
    data() {
      return {
        loading: true,
        query: {
          page_limit: 10,
          page: 1,
          name: '',
          type: '',
          enroll_status: '',
          total: 0
        },
        list: [],
        types: [
          {label: '志愿者招募', value: 'volunteer'},
          {label: '活动中心', value: 'center'}
        ]
      }
    },
    computed: {
      role_permission() {
        return this.$store.getters.role_permission
      }
    },
    watch: {},
    created() {
      that = this;
      if (this.$store.state.cache.cacheActivityQuery) this.query = this.$store.state.cache.cacheActivityQuery
      this.getList()
    },
    beforeDestroy() {
      this.$store.commit('CACHE_ACTIVITY', this.query)
    },
    methods: {
      handleChange(e) {
        if (e[0]) {
          this.query.area_code = e[0]
          this.query.village_code = e[1] || ''
          if(e[1]){
            that.$refs.area.dropDownVisible = false
          }
        } else {
          this.query.area_code = ''
          this.query.village_code = ''
        }
      },
      handleCategoryChange(e) {
        if (e[0]) {
          this.query.service_category_id = e[0]
          this.query.service_project_id = e[1] || ''
          if(e[1]){
            that.$refs.pro.dropDownVisible = false
          }
        } else {
          this.query.service_category_id = ''
          this.query.service_project_id = ''
        }
      },
      JudgeButton(list, rot) {
        let fal = false;
        list.forEach((i, l) => {
          if (i.path == rot) {
            return fal = true;
          }
        })
        return fal
      },
      submitForm() {
        this.$refs['added'].validate(valid => {
          if (!valid) return
          // TODO 提交表单
        })
      },
      handleExport() {
        this.query.flag = 'export';
        this.getList();
      },
      search() {
        this.loading = true;
        this.query.page = 1;
        this.list = [];
        this.getList()
      },
      handleDelete(row) { //删除
        this.$confirm('此操作将永久删除该记录, 是否继续?', '删除提醒', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          userInfoAPI.delActivity(row.id).then(res => {
            if (res.data.code == 0) {
              this.$message.success(res.data.msg)
              this.getList()
            }
          })
        })
      },
      reset(id) { //详情
        this.$router.push({
          path: '/activityAdd',
          query: {
            id: id,
          }
        })
      },
      getList() {
        this.loading = true
        let query = JSON.parse(JSON.stringify(this.query))
        // if (query.add_date == '全部') query.add_date = ''
        userInfoAPI.getActivityList(query).then(res => {
          if (res && res.data.code == 0) {
            this.list = res.data.data.list || []
            this.query.total = res.data.data.page.count || 0
          }
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      },
      handleSizeChange(val) {
        this.query.page_limit = val;
        this.getList();
      },
      handleCurrentChange(val) {
        this.query.page = val;
        this.getList();
      }
    }
  }
</script>
<style lang="scss" scoped>
  .record1 {
    height: 20px;
  }

  .record3 {
    margin-left: 20px;
  }

  .record2 .el-form-item {
    margin-left: 20px;
  }
</style>
